import { trustedRequest, putRequest } from 'utils/request';

export const getReferals = () => trustedRequest('/api/referals');
export const shareLink = putRequest('/api/referals/share');

export const getAgentFee = () => trustedRequest('/api/referals/fee');
